export default class DeviceManager {
    constructor(){     	
    
        this.kindle = /Kindle/i.test(platform.ua) || /Silk/i.test(platform.ua);
        this.ipadOS = (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2);
        this.iOS = platform.os.family == 'iOS' || this.ipadOS;
        this.ipad = platform.product == "iPad" || this.ipadOS;
        this.android = platform.os.family == 'Android';
        this.iphone = platform.product == "iPhone";
    
        this.mobile = this.iOS || this.android || this.kindle;
        this.desktop = !this.mobile;
    
        this.isWKWebView = this.IsWKWebView();
        this.displayBrim = this.ShouldDisplayBrim();
    
        this.renderMode = Phaser.WEBGL;

        this.gameScale = 1;

        if(this.mobile){
            this.gameScale = 0.75;
        }
    }

    IsIpad2(){
		if(platform.product == 'iPad' && window.devicePixelRatio === 1 && ((window.screen.height === 768 && window.screen.width === 1024) || (window.screen.height === 1024 && window.screen.width === 768))) {
            return true;
        }
        return false;
    }
    
    IsWKWebView(){
        if (window.webkit && window.webkit.messageHandlers) {
            return true;
        }
    
        return false;
    }
    
    ShouldDisplayBrim(){
        return (platform.product != "iPad" && !this.isWKWebView && (platform.os.family == 'iOS' && parseInt(platform.os.version, 10) > 8 || platform.ua.indexOf('like Mac OS X') != -1)&&("standalone" in window.navigator) &&!window.navigator.standalone);
    }
    
    AttemptFullscreen(scene){
        if (!this.desktop && !this.ipad) {
            if (!scene.scale.isFullscreen) {
                scene.scale.startFullscreen();
            }
        }
    }
}
